export const SELECT_PLAN = 'SELECT_PLAN';
export const GET_BILLING = 'GET_BILLING';
export const GET_COUPON = 'GET_COUPON';
export const ADD_CREDIT_CARD = 'ADD_CREDIT_CARD';
export const UPGRADE_PLAN = 'UPGRADE_PLAN';
export const LOG_OUT = 'LOG_OUT';
export const CLEAR_STORES = 'CLEAR_STORES';
export const BILLING_ERROR = 'BILLING_ERROR';
export const BILLING_LOADING = 'BILLING_LOADING';
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';



// WEBPACK FOOTER //
// ./src/app/stores/billing/billing-constants.js